import React, { useEffect, useState } from "react";
import "../styles/LoveButton.css";
import { portfolioDataRef } from "../assets/firebase_config";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
// import heartImage from "../assets/heart.svg";

const LoveButton = ({ size, loveCount }) => {
  const [clickCount, setClickCount] = useState(0);
  const [loveCounter, setLoveCounter] = useState(loveCount);

  useEffect(() => {
    const docRef = doc(portfolioDataRef, "generelData");

    // Subscribe to real-time updates
    const unsubscribe = onSnapshot(docRef, (docSnap) => {
      if (docSnap.exists()) {
        const docData = docSnap.data();
        setLoveCounter(docData?.like_count);
      } else {
        console.log("No such document!");
      }
    });

    // Clean up subscription on unmount
    return () => unsubscribe();
  }, []);

  const handleClick = async () => {
    setClickCount((prevCount) => (prevCount + 1) % 12);
    const newLoveCounter = loveCounter + 1;
    setLoveCounter(newLoveCounter);
    const docRef = doc(portfolioDataRef, "generelData");
    await updateDoc(docRef, { like_count: newLoveCounter });
  };

  const fillPercentage = clickCount * 5;

  return (
    <div className="sticky_love_button">
      <div
        className="love-button"
        onClick={handleClick}
        style={{
          width: size,
          height: size,
        }}
      >
        <div className="heart">
          <div
            className="fill"
            style={{
              height: `${fillPercentage}%`,
              bottom: `${size * 0.2}px`,
              width: `${size * 0.6}px`,
              maxHeight: `${size * 0.6}px`,
            }}
          ></div>
          {/* <img src={heartImage} alt="heart" className="heart-img"/> */}
          <svg className="heart-img" viewBox="0 0 512 512">
            <g fill="currentColor">
              <g fill="currentColor">
                <path d="M256,0C114.837,0,0,114.843,0,256s114.837,256,256,256s256-114.843,256-256S397.163,0,256,0z M381.804,281.636 l-114,114.011c-3.131,3.131-7.381,4.892-11.804,4.892c-4.423,0-8.674-1.761-11.804-4.892l-114-114.017 c-15.772-15.755-24.457-36.723-24.457-59.021s8.685-43.266,24.457-59.027c15.75-15.761,36.706-24.451,59.021-24.451 c22.315,0,43.272,8.691,59.032,24.462l7.75,7.745l7.761-7.756c15.75-15.761,36.706-24.451,59.021-24.451 s43.272,8.691,59.032,24.462c15.761,15.75,24.446,36.717,24.446,59.016S397.576,265.875,381.804,281.636z" />
              </g>
            </g>
          </svg>
        </div>
      </div>
      <p>{loveCounter}</p>
    </div>
  );
};

export default LoveButton;
